const toColor = (color: any) => {
  let rv = color;
  if (color) {
    rv = `${rv.toString(16)}`;
    while (rv.length < 6) {
      rv = `0${rv}`;
    }
    rv = `#${rv}`;
  }
  return rv;
};

export { toColor };
